module.exports = "/_next/static/images/lknalog_4-c699eb4b17e169af49aa1cfd65f5c4d7.png";